// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + "main" + "." + "71025642e5c197eabf26" + ".css";
};